'use client';

import React from 'react';
import { Dialog } from 'src/components/PulseUI/Dialog';
import { Button } from 'src/components/PulseUI/Button';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onDiscard: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

const UnsavedChangesDialog = ({
  isOpen,
  onDiscard,
  onCancel,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes that will be lost. Are you sure you want to close?',
}: UnsavedChangesDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      className="h-auto"
      disableClickOutside
      data-testid="unsaved-changes-dialog"
      aria-labelledby="unsaved-changes-title"
      aria-describedby="unsaved-changes-message"
    >
      <Dialog.Header>
        <h2
          id="unsaved-changes-title"
          className="text-lg font-semibold text-primary"
        >
          {title}
        </h2>
      </Dialog.Header>
      <Dialog.Content className="p-6">
        <p id="unsaved-changes-message" className="text-neutral-700">
          {message}
        </p>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          variant="outlined"
          color="neutral"
          onClick={onCancel}
          data-testid="unsaved-changes-keep-editing"
        >
          Keep Editing
        </Button>
        <Button
          variant="solid"
          color="danger"
          onClick={onDiscard}
          data-testid="unsaved-changes-discard"
        >
          Discard Changes
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
